
<template>
  <ul class="vx-timeline">
      <li v-for="item in data" :key="item.title">
          <!-- <div class="timeline-icon" :class="`bg-${item.color}`">
              <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
          </div> -->
          <div class="timeline-info">
              <p class="font-semibold">{{ item.title }}</p>
              <p class="activity-user p-2">Authorised On : {{ item.time }}</p>
              <template v-if="item.operation_type == 1">
                <p class="activity-user p-2">Authorised User : {{ item.user }}</p>
              </template>
              <template v-else>
                <p class="activity-user p-2">Original User : {{ item.user }}</p>
              </template>



          </div>
          <p class="activity-e-time p-2">{{ item.time }}</p>
      </li>
  </ul>
</template>

<script>
export default {
  name: "vx-timeline",
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
